var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57945 6.97682C8.57945 7.29696 8.31916 7.54991 7.98973 7.54991C7.6603 7.54991 7.4 7.29696 7.4 6.97682V4.58237C7.4 4.26223 7.6603 4.00928 7.98973 4.00928C8.31916 4.00928 8.57945 4.26223 8.57945 4.58237V6.97682ZM17.2221 6.99331V5.49273H18.5928C19.3737 5.49273 19.9986 6.10009 20 6.85894V9.62242H4V6.85894C4 6.10009 4.62498 5.49273 5.40587 5.49273H6.79411V6.99331C6.79411 7.63359 7.33163 8.15663 7.99118 8.15663C8.65004 8.15663 9.18826 7.63426 9.18826 6.99331V5.49273H14.828V6.99331C14.828 7.63359 15.3655 8.15663 16.0251 8.15663C16.6839 8.15663 17.2221 7.63426 17.2221 6.99331ZM4 11.2262V18.6806C4 19.4395 4.62498 20.0468 5.40587 20.0468H18.5941C19.375 20.0468 20 19.4395 20 18.6806V11.2262H4ZM16.0243 7.54991C16.3538 7.54991 16.6141 7.29696 16.6141 6.97682V4.58237C16.6141 4.26223 16.3538 4.00928 16.0243 4.00928C15.6949 4.00928 15.4346 4.26223 15.4346 4.58237V6.97682C15.4516 7.29696 15.7119 7.54991 16.0243 7.54991Z",
    fill: "#12246C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDark);
export default __webpack_public_path__ + "static/media/calendar-dark.f3f7997e6f409193846e16cffa45a193.svg";
export { ForwardRef as ReactComponent };